import React from "react";
import { ClockIcon } from "lucide-react";
import { useOfferClock } from "../hooks/useOfferClock";
type Props = {
  tone?: "dark" | "light";
  label?: string;
};
export function Countdown({
  tone = "dark",
  label = "Offer expires in:"
}: Props) {
  const {
    hours,
    minutes,
    seconds
  } = useOfferClock();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const isDark = tone === "dark";
  return <div className="mt-6 text-center" role="timer" aria-live="off" data-id="element-20" data-mp="3h0pbd4uhz1ps">
      <p className={`flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${isDark ? "text-gold" : "text-alert"}`} data-id="element-21" data-mp="3gyw901qx33nl">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="371zw7jtzjvd8" />
        {label}
      </p>
      <div className="mt-3 flex items-start justify-center gap-2" data-id="element-23" data-mp="10btopxe9rgvs">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="15by7xv6kappp" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="15awk0q4g68qk">
              <span className={`flex h-[62px] w-[68px] items-center justify-center rounded-xl font-display text-[34px] font-black tabular-nums ${isDark ? "bg-white text-navy-950" : "bg-navy-950 text-white"}`} data-id="element-26" data-mp="y0n11nsuz7a1">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wide ${isDark ? "text-white/70" : "text-muted"}`} data-id="element-27" data-mp="12sy5n3yjnh8x">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-display text-3xl font-black ${isDark ? "text-white" : "text-navy-950"}`} data-id="element-28" data-mp="a5kddj5sj9v5">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}